
const digest = '0ae0f15f416167f0e0e94fdcaa5e241687acfc1556b59d57e48ed035129a5605';
const css = `._menu_sa0ct_1 {
  --aha-menu-content--max-height: 200px;
  z-index: 20;
  opacity: 1;
  transition: opacity 0.2s;
}

._menu_sa0ct_1 aha-menu-content {
  animation: unset;
}

._divider_sa0ct_12:not(:last-child) {
  border-top: 1px solid var(--theme-light-border);
  margin: 5px 0;
}

._item_sa0ct_17 {
  font-size: 13px;
  cursor: pointer;
  margin-left: var(--aha-menu-content--horizontal-padding);
  margin-right: var(--aha-menu-content--horizontal-padding);
  padding: var(--aha-menu-content--vertical-padding)
    var(--aha-menu-content--horizontal-padding);
  border-radius: var(--Common--border-radius);
}

._loading_sa0ct_27 {
  background: var(--theme-primary-background);
  border: 1px solid var(--theme-secondary-border);
}

._selected_sa0ct_32 {
  background-color: var(--theme-menu-hover-background);
  color: var(--theme-menu-highlighted-text);
}

._hidden_sa0ct_37 {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s, visibility 0.3s;
}

._searchingText_sa0ct_43 {
  display: flex;
  gap: 10px;
  align-items: center;
  --aha-spinner--size: 20em;
}

/* Styled as if it were an aha-menu-content element */
._menuContent_sa0ct_51 {
  /* Core aha-menu-content styles */
  font-weight: initial;
  transform-origin: center;
  display: block;
  background: var(--theme-primary-background);
  border-radius: var(--Common--border-radius);
  width: max-content;
  min-width: 200px;
  box-shadow: var(--theme-shadow-shallow);
  border: 1px solid var(--theme-light-border);
  font-size: var(--aha-menu-content--font-size, 13px);
  box-sizing: border-box;
  outline: none;
  z-index: 10000;
  text-align: left;
  /* Inner container styles */
  max-height: var(--aha-menu-content--max-height, calc(100vh - 2rem));
  max-width: var(--aha-menu-content--max-width, calc(100vw - 2rem));
  overflow: auto;
  padding-top: var(--aha-menu-content--vertical-padding);
  padding-bottom: var(--aha-menu-content--vertical-padding);
  padding-left: var(--aha-menu-content--horizontal-padding);
  padding-right: var(--aha-menu-content--horizontal-padding);
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"menu":"_menu_sa0ct_1","divider":"_divider_sa0ct_12","item":"_item_sa0ct_17","loading":"_loading_sa0ct_27","selected":"_selected_sa0ct_32","hidden":"_hidden_sa0ct_37","searchingText":"_searchingText_sa0ct_43","menuContent":"_menuContent_sa0ct_51"};
export { css, digest };
  